import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import { connect } from 'react-redux';
import Header from './layout/Header';
import * as toursActions from '../actions/tours';
import { Link } from 'react-router';
import { browserHistory } from 'react-router'
import Helmet from "react-helmet";



class Landmark extends Component {

    componentWillMount() {

        this.props.toursActions.setMapConfig({
            active: false,
            fixed: true,
            type: 'ROADMAP',
            activeRoute: true
        });

        this.props.toursActions.setScroll({scrollY: 1000, opacity: 0.2});
        this.props.toursActions.fetchLandmark(this.props.params.param_id);
    }

    componentDidMount() {
        
    }

    eventUndo(e) {
        //console.log('back');
        //console.log(browserHistory);
        browserHistory.goBack();
    }

    componentDidUpdate() {

    }


    componentWillUnmount() {

        this.props.toursActions.setMapConfig({
            active: true,
            fixed: false,
            activeRoute: false
        });
    }

    
    
    render () {
        const { landmark, seo } = this.props;

        let meta = [
            {"name": "description", "content": (seo.description)?seo.description:(landmark.content)?landmark.content.substr(0, 200):""}
        ];

        return (


            <section className="section " ref="main">
                <Helmet
                    title={(seo.title)?seo.title:landmark.title}
                    meta={meta}
                />
                <div className="section__content">
                    <Header />
                    <div>

                        <div className="container landmark">
                            <div className="landmark__close" onClick={this.eventUndo.bind(this)}>

                            </div>
                            <h1>{landmark.title}</h1>
                            <div className="container__description">
                                {landmark.content}
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


Landmark.need = [
    {
        action: toursActions.fetchLandmark
    }
];



function mapStateToProps(state) {

    return {
        landmark: state.tours.landmark,
        seo: state.user.seo
    };
}


function mapDispatchToProps(dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Landmark)





// WEBPACK FOOTER //
// ./src/common/components/Landmark.js